/*
 * @Author: caiqin.xie
 * @since: 2023-09-08 10:05:01
 * @lastTime: 2023-11-10 16:27:11
 * @LastEditors: caiqin.xie
 * @message: 门店-空内容
 */
import React from "react";
import styles from "./index.module.scss";


interface IProps {
  words: Record<string, string>;
  className?: string;
}

const CustomEmpty = (props:IProps) => {
  const {words, className} = props
  return (
    <div className={`${styles['empty-wrap']} ${className}`}>
      <div className={`${styles['empty-content']}`}>
        {words?.common_search_null}
        {/* 0 search result */}
      </div>
    </div>
  )
}
export default CustomEmpty